module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/gastos-detallados-categoria/gastos-detallados-categoria.component.scss
// module id = ./src/app/gastos/gastos-detallados-categoria/gastos-detallados-categoria.component.scss
// module chunks = main